<template>
  <v-app id="v-app" standalone>

    <v-navigation-drawer
      persistent
      v-model="drawer"
      light
      enable-resize-watcher
      absolute
    >
      <v-card>
        <div style="text-align: center;">
          <img :src="imageUrl" style="height: 90px; margin-top: 10px; margin-bottom: 10px;"/>
        </div>
      </v-card>

      <v-list dense>

        <v-list-tile @click="goTo('Home')" :class="{ 'list__tile--active': isActive('Home') }">
          <v-list-tile-action>
            <img src="/static/img/icons/favicon-32x32.png" />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="menu-entry-title">
              Home / Map
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="goTo('Questions')" :class="{ 'list__tile--active': isActive('Questions') }">
          <v-list-tile-action>
            <img src="/static/img/menu/challenges_list.png" />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="menu-entry-title">
              Challenges List
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="goTo('TeamLeaderboard')" :class="{ 'list__tile--active': isActive('TeamLeaderboard') }">
          <v-list-tile-action>
            <img src="/static/img/menu/picto_winner.png" />
          </v-list-tile-action>
          <v-list-tile-title class="menu-entry-title">
            Team Leaderboard
          </v-list-tile-title>
        </v-list-tile>

        <v-divider></v-divider>

        <v-list-tile @click="launchTutorial()" :class="{ 'list__tile--active': isActive('About') }">
          <v-list-tile-action>
            <img src="/static/img/menu/eye.png" />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="menu-entry-title">
              Tutorial
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="goTo('Photos')" :class="{ 'list__tile--active': isActive('Photos') }">
          <v-list-tile-action>
            <img src="/static/img/menu/picto_photos.png" />
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="menu-entry-title">
              Photos
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>

    <v-toolbar class="geogaming-blue-bg" dark>
      <v-toolbar-side-icon @click.native.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{gameDisplayedName}}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn v-if="showTeamLoginButton()" primary @click="goTo('TeamLogin')" :class="{ 'list__tile--active': isActive('TeamLogin') }">
        <i class="material-icons">people</i>  Sign In
      </v-btn>
      <team-avatar
        @logout="logout">
      </team-avatar>
    </v-toolbar>

    <main>
      <router-view></router-view>
    </main>

  </v-app>
</template>

<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import { mapActions, mapGetters } from 'vuex'
  import TeamLogin from '@/components/TeamLogin'
  import { generateFingerprint } from '@/services/fingerprint'
  import TeamAvatar from './components/single/TeamAvatar'
  import _ from 'lodash'

  import selected from './geogaming-selected'
  import config from './geogaming-config'

  const DEFAULT_CONFIG_NAME = 'default'
  const configName = selected.envName
  console.log(' > stage:' + configName)

  const DEFAULT_TITLE = config[configName] ? config[configName].title : config[DEFAULT_CONFIG_NAME].title
  const DEFAULT_IMAGE_URL = config[configName] ? config[configName].logo : config[DEFAULT_CONFIG_NAME].logo

  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.GOOGLE_MAPS_API_KEY,
      // Force maps to load the 'geometry' library from the beginning
      libraries: 'geometry',
    }
  })

  const getters = mapGetters([
    'team',
    'fingerprint',
    'game',
  ])

  const actions = mapActions([
    'logoutTeam'
  ])

  export default {
    name: 'app',
    components: {
      TeamAvatar,
      TeamLogin,
    },
    data() {
      return {
        drawer: true,
        navigationDrawerElement: null
      }
    },
    mounted() {
      this.$store.commit('SET_DRAWER_STATE', this.drawer)
      this.generateAndStoreFingerprint()
      this.navigationDrawerElement = this.$el.querySelector('.navigation-drawer')
    },
    watch: {
      'drawer': function (drawer) {
        this.$store.commit('SET_DRAWER_STATE', drawer)
      }
    },
    computed: {
      ...getters,
      imageUrl: function () {
        if (this.game) {
          return this.game.imageUrl ? this.game.imageUrl : _.get(this.$store.state.tenant, 'logoUrl', DEFAULT_IMAGE_URL)
        } else {
          return _.get(this.$store.state.tenant, 'logoUrl', DEFAULT_IMAGE_URL)
        }
      },
      gameDisplayedName: function () {
        if (this.game) {
          return this.game.gameDisplayedName ? this.game.gameDisplayedName : _.get(this.$store.state.tenant, 'title', DEFAULT_TITLE)
        } else {
          return _.get(this.$store.state.tenant, 'title', DEFAULT_TITLE)
        }
      }
    },
    methods: {
      ...actions,
      goTo(pathName) {
        if (this.navigationDrawerElement.classList.contains('navigation-drawer--is-mobile')) {
          this.drawer = false
        }
        this.$router.push({ name: pathName })
      },
      showTeamLoginButton() {
        if (!this.team && this.$route.name !== 'TeamLogin') {
          return true
        }
        return false
      },
      generateAndStoreFingerprint() {
        generateFingerprint(fingerprint => {
          // Store fingerprint
          this.$store.commit('SET_FINGERPRINT', fingerprint)
        })
      },
      logout() {
        this.logoutTeam()
        this.goTo('TeamLogin')
      },
      isActive(routeName) {
        return routeName === this.$router.currentRoute.name
      },
      launchTutorial() {
        this.$store.commit('LAUNCH_TUTORIAL', true)
        this.$store.commit('IS_TUTORIAL_IN_PROGRESS', true)
        this.goTo('Home')
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  @import 'assets/styles/style.scss';
  @import 'assets/styles/colors.scss';

  .geogaming-blue-bg {
    background-color: $geogaming-dark-blue-color !important;
    border-color: $geogaming-dark-blue-color !important;
  }

  .geogaming-blue {
    color: $geogaming-dark-blue-color !important;
  }

  .menu-entry-title {
    color: #0E2356 !important;
    font-weight: bold;
  }

  #v-app {
    min-height: unset;
    height: 100%;
    display: flex;
    flex-direction: column;

    nav {
      flex: 0 0 auto;

      a {
        text-decoration: none;
      }
    }

    > main {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
    }
  }

  .navigation-drawer {

    .card {
      margin-bottom: 5px;
    }

    .list {

      .divider {
        margin: 5px 0;
      }

      .list__tile__action {
        min-width: 20px;
        margin-right: 25px;
        justify-content: center;

        img {
          max-width: 20px;
          max-height: 20px;
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/App.vue